// extracted by mini-css-extract-plugin
export default {"root":"root--v6uRL","main":"main--SAISP","side":"side--djS03","withSeparator":"withSeparator--B5TIv"};